export default {
	game_id: "nine_stars",
	gameName: "9 Stars",

	stageWidth: 1280,
	stageHeight: 720,

	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
		"framework/src/vendor/ph.js",
	],

	game: {
		webfonts: ["BowlbyOne", "UbuntuMono-Regular", "Audiowide-Regular"],
		audio: {
			tracks: [],
		},
		freespins: {
			autostart: false,
		},
	},
	system: {
		audio: {
			tracks: [
				{
					name: 'Jackpot_sound',
					classVol: 'volume.normalWin',
					url: `assets/JokerWinBanner/Jackpot_sound.mp3`,
					loop: false,
				},
				{
					name: 'JokerBonus_alert',
					classVol: 'volume.normalWin',
					url: `assets/JokerWinBanner/JokerBonus_alert.mp3`,
					loop: false,
				},
			],
		},
	},
};
